import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaGlobe } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Yadi Legal Services</h3>

            <p>
              Professional legal services delivered with integrity, expertise,
              and a commitment to achieving the best outcomes for our clients.
            </p>

            <div className="footer-contact">
              <p>
                📍 Flat No.103, Dikshith Residency, Moosarambagh, Malakpet,
                Hyderabad - 500036
              </p>

              <p>
                ✉️{" "}
                <a href="mailto:yadishwarn.advocate@gmail.com">
                  yadishwarn.advocate@gmail.com
                </a>
              </p>

              <p>
                📞{" "}
                <a href="tel:+919398604124">+91 9398604124</a>
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/areas-of-practice">Areas Of Practice</Link></li>
              <li><Link to="/lawyers">Our Advocates</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><Link to="/internship">Internship</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Practice Areas</h4>
            <ul className="footer-links">
              <li>Civil Law</li>
              <li>Criminal Law</li>
              <li>Corporate Law</li>
              <li>Family Law</li>
              <li>Property Law</li>
              <li>Intellectual Property</li>
              <li>Labor Law</li>
              <li>Tax Law</li>
              <li>Environmental Law</li>
              <li>More +</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-disclaimer">
            <p>
              <strong>Disclaimer:</strong> This website is for informational
              purposes only and does not constitute legal advice. The information
              provided should not be used as a substitute for professional legal
              counsel.
            </p>
          </div>

          <div className="footer-copyright">
            <p>© 2026 Yadi Legal Services. All rights reserved.</p>

            <div className="developer-credit">
              <span className="developer-text">
                Developed by{" "}
                <strong className="company-name">Design Dynasty</strong>
              </span>

              <a
                href="https://designdynasty.in"
                target="_blank"
                rel="noopener noreferrer"
                className="developer-link glow-gold"
              >
                <FaGlobe className="dev-icon" />
                <span>designdynasty.in</span>
              </a>

              <a
                href="https://wa.me/919182183823"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link glow-gold"
              >
                <FaWhatsapp className="dev-icon whatsapp-icon" />
                <span>WhatsApp</span>
              </a>

              <a
                href="tel:+919182183823"
                className="phone-link glow-gold"
              >
                <span>📞</span>
                <span>9182183823</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;